import { render, staticRenderFns } from "./NoticiasHomeComp.vue?vue&type=template&id=d89f223e&scoped=true&"
import script from "./NoticiasHomeComp.vue?vue&type=script&lang=js&"
export * from "./NoticiasHomeComp.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasHomeComp.vue?vue&type=style&index=0&id=d89f223e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89f223e",
  null
  
)

export default component.exports